import React, { RefObject, useCallback, useMemo } from 'react';

import { EMediaWidth } from '@r1-frontend/ui-react/tokens/mediaWidth';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { commonPropsSlider, headerCarouselRowData } from '~/src/features/yandex-landing/data';
import type { TBenefits } from '~/src/features/yandex-landing/data/types';
import type { IStationSections } from '~/src/features/yandex-landing/types';
import { dataLayerPushWrap } from '~/src/features/yandex-landing/utils';
import { useScroll } from '~/src/helpers/hooks/useScroll';

import * as ST from './styled';

interface ICarouselRow {
    catalogMimicFormRef: RefObject<HTMLDivElement>,
    stationSections: IStationSections[],
}

const CarouselRow: React.FC<ICarouselRow> = ({ catalogMimicFormRef, stationSections }) => {
    const isTablet = useMatchMedia(EMediaWidth.tabletOnly);
    const isMobile = useMatchMedia(EMediaWidth.mobile);
    const scrollToRef = useScroll({ alignment: 'start' });

    const filterStations = useCallback((section: TBenefits) => {
        return stationSections.find(item => item.type === section.type)?.inStock;
    }, [stationSections]);

    const yandexStationData = useMemo((): TBenefits[] => {
        return headerCarouselRowData.filter(filterStations);
    }, [filterStations]);

    const onScrollWrapper = useCallback((text: string) => {
        dataLayerPushWrap({ label: text, callback: () => scrollToRef(catalogMimicFormRef) });
    }, []);

    return (<>
        {!isMobile && <ST.CarouselWrapperTablet {...commonPropsSlider} slidesToShow={isTablet ? 2 : 4}>
            {yandexStationData.map(({ id, text, imgUrl, imgWebpUrl }) => (
                <ST.StationTag
                    key={id}
                    text={text}
                    onClick={() => onScrollWrapper(text)}
                >
                    <ST.StationImg imgUrl={imgUrl} imgWebpUrl={imgWebpUrl} />
                    <ST.TagText>
                        {text}
                    </ST.TagText>
                </ST.StationTag>
            ))}
        </ST.CarouselWrapperTablet>}
    </>);
};

export default CarouselRow;
